import React, {Component} from 'react';
import Parser from 'rss-parser';
import moment from 'moment';
import {trackEventByUrl} from "../../helpers/events";
import './PressReleasesRSS.scss';

class PressReleasesRSS extends Component {

    state = {
        rss: null
    };

    componentDidMount() {
        const parser = new Parser();
        const rssUrl = 'https://content.marketaxess.com/press-feed.php';

        parser.parseURL(rssUrl).then(feed => {
            const items = feed.items.slice(0,5);
            this.setState({rss: items});
        })

    }

    render() {
        if (!this.state.rss) return null;

        return (
            <div className="container">
                <table className="pressReleases">
                    <thead>
                    <tr>
                        <th id="view-field-nir-news-date-table-column"
                            className="views-field views-field-field-nir-news-date" scope="col">Date
                        </th>
                        <th id="view-field-nir-news-title-table-column"
                            className="views-field views-field-field-nir-news-title" scope="col">Title
                        </th>
                        <th id="view-field-nir-news-supp-format-table-column"
                            className="views-field views-field-field-nir-news-supp-format" scope="col">Formats
                        </th>
                    </tr>
                    </thead>
                    <tbody>

                    {this.state.rss.map(post => (
                        <tr>
                            <td data-before="Date">
                                <div className="nir-widget--field nir-widget--news--date-time">
                                    {moment(post.pubDate).format('MMMM D, YYYY')}
                                </div>
                            </td>
                            <td data-before="Title">
                                <div className="nir-widget--field nir-widget--news--headline">
                                    <a onClick={trackEventByUrl(post.link, post.title)} href={post.link}>
                                        {post.title}
                                    </a>
                                </div>
                            </td>
                        </tr>
                    ))}

                    </tbody>
                </table>
            </div>
        )
    }
}

export default PressReleasesRSS;



// WEBPACK FOOTER //
// ./frontend/components/PressReleasesRSS/PressReleasesRSS.jsx